import React, { useState, useCallback, lazy, Suspense } from "react"
import DOMPurify from "dompurify"
import Box from "@mui/material/Box"
import InputLabel from "@mui/material/InputLabel"
import FormHelperText from "@mui/material/FormHelperText"
import { useTheme } from "@mui/material"
const SummernoteEditor = lazy(() => import("shared/ui/SummernoteEditor"))

const getBorderColor = ({ error, focused, theme }) => {
  if (error) return theme.palette.error.main
  if (focused) return theme.palette.primary.main
  return "#bdbdbd"
}

const getHoverBorderColor = ({ error, focused, theme }) => {
  if (error) return theme.palette.error.main
  if (focused) return "primary.main"
  return "black"
}

export const Wysiwyg = ({
  name,
  label,
  sx = {},
  value,
  onChange,
  disabled,
  readOnly,
  placeholder,
  onFocus,
  onBlur,
  error,
  helperText
}) => {
  const theme = useTheme()
  const [focused, setFocused] = useState(false)

  const onFocusHandler = useCallback(() => {
    setFocused(true)
    onFocus?.()
  }, [onFocus])

  const onBlurHandler = useCallback(() => {
    setFocused(false)
    onBlur?.()
  }, [onBlur])

  if (readOnly) {
    return (
      <>
        {label && (
          <Box marginBottom="10px">
            <InputLabel>{label}</InputLabel>
          </Box>
        )}
        <div dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(value) }} />
      </>
    )
  }

  return (
    <>
      {label && (
        <Box marginBottom="10px">
          <InputLabel>{label}</InputLabel>
        </Box>
      )}

      <Box
        data-testid={name}
        sx={{
          border: "1px solid",
          borderRadius: "8px",
          borderColor: getBorderColor({ error, focused, theme }),
          outline: focused
            ? `1px solid ${getBorderColor({ error, focused, theme })}`
            : "none",
          "&:hover": {
            borderColor: getHoverBorderColor({ error, focused, theme })
          },
          ...sx
        }}
        className={focused ? "focused" : ""}
      >
        <Suspense fallback={null}>
          <SummernoteEditor
            value={value}
            onChange={onChange}
            onFocus={onFocusHandler}
            onBlur={onBlurHandler}
            placeholder={placeholder}
            disabled={disabled}
          />
        </Suspense>
      </Box>
      {helperText && (
        <FormHelperText error={error}>{helperText}</FormHelperText>
      )}
    </>
  )
}
